import api, { getErrorMessage } from './api';

const BASE = '/api/v1/chat';

const wrap = async (fn) => {
  try {
    const response = await fn();
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

const chatService = {
  getRealtimeTicket: () => wrap(() => api.get(`${BASE}/realtime/ticket`)),
  getUnreadCount: () => wrap(() => api.get(`${BASE}/unread-count`)),
  listConversations: () => wrap(() => api.get(`${BASE}/conversations`)),
  getConversation: (id) => wrap(() => api.get(`${BASE}/conversations/${id}`)),
  // Opens (or finds) the direct thread with one colleague.
  openDirect: (userId) =>
    wrap(() => api.post(`${BASE}/conversations`, { kind: 'direct', user_id: userId })),
  createGroup: ({ name, memberIds }) =>
    wrap(() =>
      api.post(`${BASE}/conversations`, { kind: 'group', name: name || null, member_ids: memberIds })
    ),
  renameGroup: (id, name) => wrap(() => api.patch(`${BASE}/conversations/${id}`, { name })),
  addMembers: (id, userIds) =>
    wrap(() => api.post(`${BASE}/conversations/${id}/members`, { user_ids: userIds })),
  removeMember: (id, userId) =>
    wrap(() => api.delete(`${BASE}/conversations/${id}/members/${userId}`)),
  // Oldest-first page. `before` pages back; `after` is the polling cursor.
  listMessages: (id, { before, after, limit } = {}) =>
    wrap(() =>
      api.get(`${BASE}/conversations/${id}/messages`, {
        params: { before: before || undefined, after: after || undefined, limit },
      })
    ),
  sendMessage: (id, body) => wrap(() => api.post(`${BASE}/conversations/${id}/messages`, { body })),
  markRead: (id) => wrap(() => api.post(`${BASE}/conversations/${id}/read`)),
  typing: (id) => wrap(() => api.post(`${BASE}/conversations/${id}/typing`)),
  // Recipient search goes through the same endpoint as the recognition picker,
  // so team isolation is enforced server-side.
  searchColleagues: (search) =>
    wrap(() => api.get('/api/v1/users/colleagues', { params: { skip: 0, limit: 50, search: search || undefined } })),
};

export default chatService;
